import { queryOptions } from '@tanstack/react-query'

import { ProgressAPI } from '../dal/progress-dal'
import { queryKeys } from './query-keys'

export const progressSnapshotQueryOptions = (yearWeek: string) =>
  queryOptions({
    queryKey: queryKeys.progress.snapshot(yearWeek),
    queryFn: () => ProgressAPI.getProgressSnapshot(yearWeek),
  })
